import React, {Component} from 'react'

import CRUDManagerGenerator from '../generators/CRUDGenerator'
import {checkPermission, MISC_CAN_CREATE_CONTACT_MEDIUMS, MISC_CAN_EDIT_CONTACT_MEDIUMS} from "../../../lib/permissions";

const create = {
    table: 'contact_mediums',
    mutationType: 'upsert_',
    schema: {
        title: 'Create Contact Medium',
        type: 'object',
        required: ['description'],
        properties: {
            description: {type: 'string', title: 'Description'}
        }
    }
}

const update = {
    table: 'contact_mediums',
    mutationType: 'upsert_',
    schema: {
        title: 'Update Contact Medium',
        type: 'object',
        required: ['description'],
        properties: {
            contact_medium_id: {type: 'integer'},
            description: {type: 'string', title: 'Description'}
        }
    },
    uiSchema: {
        contact_medium_id: {"ui:widget": "hidden"},
    },
}

const read = {
    title: 'Contact Mediums',
    description: 'Contact Mediums define how a client or contact can be communicated with.',
    table: 'contact_mediums',
    fields: ['contact_medium_id', 'description'],
    uniqueKey: 'contact_medium_id',
    columns: [
        {Header: 'ID', accessor: 'contact_medium_id', maxWidth: '100'},
        {Header: 'Desc', accessor: 'description'}
    ]
}

const config = {
    create,
    read,
    update
}


const CRUDManager = CRUDManagerGenerator(config)

class ContactMediums extends Component{

    render(){
        return (
            <CRUDManager
                canCreate={checkPermission(MISC_CAN_CREATE_CONTACT_MEDIUMS)}
                canEdit={checkPermission(MISC_CAN_EDIT_CONTACT_MEDIUMS)}
            />
        )
    }
}

export default ContactMediums